import { Predicate } from '../types';

export interface Matcher<T> extends Predicate<T, boolean> {
  message: () => string;
}

export class BaseMatcher<T> implements Matcher<T> {
  constructor(
    private readonly assert: (input: T) => boolean,
    public readonly message: () => string,
  ) {}

  apply(input: T): boolean {
    return this.assert(input);
  }
}
